var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1315 2.9896C17.7173 2.40381 17.7173 1.45407 17.1315 0.86828C16.5457 0.282493 15.596 0.282493 15.0102 0.86828L8.99979 6.87868L2.98939 0.86828C2.4036 0.282495 1.45386 0.282494 0.868069 0.86828C0.282283 1.45407 0.282283 2.40381 0.868069 2.9896L6.87847 9L0.86805 15.0104C0.282265 15.5962 0.282264 16.5459 0.86805 17.1317C1.45384 17.7175 2.40358 17.7175 2.98937 17.1317L8.99979 11.1213L15.0102 17.1317C15.596 17.7175 16.5457 17.7175 17.1315 17.1317C17.7173 16.546 17.7173 15.5962 17.1315 15.0104L11.1211 9L17.1315 2.9896Z",
    fill: "#101112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6ab71ca3001866ec40903ef8d314fcc5.svg";
export { ForwardRef as ReactComponent };